export default "__VITE_ASSET__3c193b40__"